<template>
  <div
    :style="{height: scrollBoxHeight +'px'}"
    class="no-data"
  >
    <van-image :src="require('@/assets/images/no-data.png')" />
    <div class="no-data-text">
      暂无数据
    </div>
  </div>
</template>

<script>
export default {
  name: 'NoData'
}
</script>

<style lang="scss" scoped>
.no-data {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  image {
    width: 500px;
    height: 260px;
  }

  .no-data-text {
    font-size: 28px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
  }
}
</style>
